import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, Routes, Route } from "react-router-dom";
import DashboardSection from "./Dashbord";
import OrderSection from "./OrderSection";
import UserProfile from "./UserProfile";

const UserSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("dashboard");
  const [isOpen, setIsOpen] = useState(false);

  // Sync active section with URL
  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/order-section")) {
      setActiveSection("orders");
    } else if (path.includes("/profile")) {
      setActiveSection("profile");
    } else if (path.includes("/dashboard")) {
      setActiveSection("dashboard");
    }
  }, [location]);

  // ... rest of your component remains the same ...

  return (
    <div className="min-h-screen w-full mt-10 font-['Poppins',sans-serif] bg-white">
      {/* ... your existing JSX for mobile top bar, sidebar, etc. ... */}
      
      {/* Main Content */}
      <main className="flex-1 w-full bg-white">
        <div className="px-4 md:px-8 py-6">
          <div className="max-w-6xl mx-auto">
            <div className="hidden md:block mb-6">
              <h1 className="text-2xl font-semibold text-gray-900">
                User Dashboard
              </h1>
              <p className="text-sm text-gray-500">
                Manage your account details and orders.
              </p>
            </div>

            <div className="rounded-2xl border border-gray-200 bg-white shadow-sm">
              <div className="p-4 md:p-6">
                <Routes>
                  <Route path="/" element={<DashboardSection />} />
                  <Route path="/dashboard" element={<DashboardSection />} />
                  <Route path="/order-section" element={<OrderSection />} />
                  <Route path="/profile" element={<UserProfile />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default UserSidebar;